<template>
  <div>
    <multiselect
      v-model="currentValue"
      label="name"
      track-by="id"
      placeholder
      selectLabel
      open-direction="bottom"
      :options="options"
      :multiple="true"
      :searchable="true"
      :loading="loading"
      :internal-search="false"
      :clear-on-select="false"
      :close-on-select="false"
      :options-limit="30"
      :max-height="300"
      :option-height="28"
      :show-no-results="true"
      :hide-selected="true"
      @search-change="search"
      @input="updateValue"
    >
      <template slot="tag" slot-scope="{ option, remove }">
        <Tag closable @on-close="remove(option)">{{ option.name }}</Tag>
      </template>

      <template slot="option" slot-scope="{ option }">
        <span>{{ option.name }}</span>
        <span style="float:right;color:#ccc, padding-right: 100px;">
          {{ option.geo_name }}
        </span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import { getTsQueryValue } from "@/utils/common";
import "../../node_modules/vue-multiselect/dist/vue-multiselect.min.css";

export default {
  components: { Multiselect },
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      currentValue: this.value || [],
      options: [],
      loading: false,
    };
  },
  watch: {
    value() {
      this.currentValue = this.value || [];
    },
  },
  created() {
    this.currentValue = this.value || [];
  },
  mounted() {
    this.currentValue = this.value || [];
  },
  methods: {
    optionLabel(publisher) {
      if (publisher.geo_name === null) {
        return publisher.name;
      }
      return publisher.name + " / " + publisher.geo_name;
    },
    search(query) {
      if (query !== "" && query.length >= 2) {
        this.loading = true;
        axios
          .get("/psql/publishers_view", {
            params: {
              select: "id, name, iso3, geo_name",
              name: getTsQueryValue(query),
              order: `name`,
            },
          })
          .then(response => {
            this.options = response.data;
            this.loading = false;
          })
          .catch(error => {
            console.error(error);
            this.$Notice.error("error searching options");
            this.options = [];
            this.loading = false;
          });
      }
    },
    updateValue(newValue) {
      this.$emit("input", newValue);
      this.$emit("on-change", newValue);
    },
  },
};
</script>

<style>
.ivu-tooltip {
  width: 100%;
}
.ivu-tooltip-rel {
  width: 100%;
}

.multiselect {
  min-height: 24px;
}

.multiselect__tags {
  min-height: 12px;
  padding: 0px 4px 2px 4px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
}

.multiselect__input {
  margin: 8px 0px 8px 0px;
  font-size: 12px;
}

.multiselect__option {
  color: #495060;
  font-size: 12px;
  min-height: 12px;
  line-height: normal;
  padding: 7px 16px;
}

.multiselect__option:hover {
  background: #f3f3f3;
}

.multiselect__option--highlight {
  color: #495060;
  background: #f3f3f3;
  font-size: 12px;
}

.multiselect__option--highlight:after {
  background: #f3f3f3;
  color: #495060;
}

.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #f3f3f3;
}
.multiselect__tag {
  background: #f3f3f3;
}
</style>
